import { render, staticRenderFns } from "./Leaderboard_Popover_Category.vue?vue&type=template&id=58645b4b&"
import script from "./Leaderboard_Popover_Category.vue?vue&type=script&lang=js&"
export * from "./Leaderboard_Popover_Category.vue?vue&type=script&lang=js&"
import style0 from "./Leaderboard_Popover_Category.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports